import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgRem } from '../../fg-math.js';

const moduloDef = {
  type: FgBlockType.Modulo,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any), sockIn("b", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    const b = getDataValue(ctx, env, block, "b");
    setDataValue(ctx, block, "value", fgRem(a, b));
  }
};

export { moduloDef };
//# sourceMappingURL=modulo.js.map
